import { render, staticRenderFns } from "./member-detail.vue?vue&type=template&id=2f8e9743&scoped=true";
import script from "./member-detail.vue?vue&type=script&lang=jsx";
export * from "./member-detail.vue?vue&type=script&lang=jsx";
import style0 from "./member-detail.vue?vue&type=style&index=0&id=2f8e9743&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "2f8e9743", null);
export default component.exports;